import apiFetch from "@wordpress/api-fetch";
function getCommonHeaders() {
    return {
        "Content-Type": "application/json",
        "X-WPQT-USER-API-Nonce": window.wpqt_user.userApiNonce,
    };
}
function getUserPageStatusRequest(pageHash) {
    return apiFetch({
        path: `/wpqt/v1/user-pages/${pageHash}/status`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
function setUpUserPageRequest(pageHash, data) {
    return apiFetch({
        path: `/wpqt/v1/user-pages/${pageHash}/setup`,
        data,
        method: "POST",
        headers: getCommonHeaders(),
    });
}
function logInUserPageRequest(pageHash, password) {
    return apiFetch({
        path: `/wpqt/v1/user-pages/${pageHash}/login`,
        method: "POST",
        data: { password },
        headers: getCommonHeaders(),
    });
}
function getOverviewRequest(pageHash) {
    return apiFetch({
        method: "GET",
        path: `/wpqt/v1/user-pages/${pageHash}/overview`,
        headers: getCommonHeaders(),
    });
}
function getAssignedTasksRequest(pageHash) {
    return apiFetch({
        method: "GET",
        path: `/wpqt/v1/user-pages/${pageHash}/assigned-tasks`,
        headers: getCommonHeaders(),
    });
}
function getAssignableTasksRequest(pageHash) {
    return apiFetch({
        method: "GET",
        path: `/wpqt/v1/user-pages/${pageHash}/assignable-tasks`,
        headers: getCommonHeaders(),
    });
}
function getTaskDataRequest(pageHash, taskHash) {
    return apiFetch({
        method: "GET",
        path: `/wpqt/v1/user-pages/${pageHash}/tasks/${taskHash}`,
        headers: getCommonHeaders(),
    });
}
function assignTaskToUser(pageHash, taskHash) {
    return apiFetch({
        method: "POST",
        path: `/wpqt/v1/user-pages/${pageHash}/tasks/${taskHash}/users`,
        headers: getCommonHeaders(),
    });
}
function unAssignTaskFromUser(pageHash, taskHash) {
    return apiFetch({
        method: "DELETE",
        path: `/wpqt/v1/user-pages/${pageHash}/tasks/${taskHash}/users`,
        headers: getCommonHeaders(),
    });
}
function changeTaskStageRequest(pageHash, taskHash, stageId) {
    return apiFetch({
        method: "PATCH",
        path: `/wpqt/v1/user-pages/${pageHash}/tasks/${taskHash}/stage`,
        data: { stageId },
        headers: getCommonHeaders(),
    });
}
function changeTaskDoneStatusRequest(pageHash, taskHash, isDone) {
    return apiFetch({
        method: "PATCH",
        path: `/wpqt/v1/user-pages/${pageHash}/tasks/${taskHash}/done`,
        data: { done: isDone },
        headers: getCommonHeaders(),
    });
}
function logoutUserPageRequest(pageHash) {
    return apiFetch({
        method: "POST",
        path: `/wpqt/v1/user-pages/${pageHash}/logout`,
        headers: getCommonHeaders(),
    });
}
function getTaskCommentsRequest(pageHash, taskHash) {
    return apiFetch({
        method: "GET",
        path: `/wpqt/v1/user-pages/${pageHash}/tasks/${taskHash}/comments`,
        headers: getCommonHeaders(),
    });
}
function addTaskCommentRequest(pageHash, taskHash, comment) {
    return apiFetch({
        method: "POST",
        path: `/wpqt/v1/user-pages/${pageHash}/tasks/${taskHash}/comments`,
        data: { comment },
        headers: getCommonHeaders(),
    });
}
function getUserCommentsRequest(pageHash) {
    return apiFetch({
        method: "GET",
        path: `/wpqt/v1/user-pages/${pageHash}/user/comments`,
        headers: getCommonHeaders(),
    });
}
function addUserCommentRequest(pageHash, comment) {
    return apiFetch({
        method: "POST",
        path: `/wpqt/v1/user-pages/${pageHash}/user/comments`,
        data: { comment },
        headers: getCommonHeaders(),
    });
}
function getUserPageCommentsRequest(pageHash) {
    return apiFetch({
        method: "GET",
        path: `/wpqt/v1/user-pages/${pageHash}/comments`,
        headers: getCommonHeaders(),
    });
}
function getUserPageUserDataRequest(pageHash) {
    return apiFetch({
        method: "GET",
        path: `/wpqt/v1/user-pages/${pageHash}/user`,
        headers: getCommonHeaders(),
    });
}
/*
  ==================================================================================================================================================================================================================
  Custom Field requests
  ==================================================================================================================================================================================================================
*/
function updateCustomFieldValueRequest(pageHash, entityId, entityType, customFieldId, value) {
    return apiFetch({
        method: "PATCH",
        path: `/wpqt/v1/user-pages/${pageHash}/custom-fields/${customFieldId}`,
        data: { entityId, entityType, customFieldId, value },
        headers: getCommonHeaders(),
    });
}
export { addTaskCommentRequest, addUserCommentRequest, assignTaskToUser, changeTaskDoneStatusRequest, changeTaskStageRequest, getAssignableTasksRequest, getAssignedTasksRequest, getOverviewRequest, getTaskCommentsRequest, getTaskDataRequest, getUserCommentsRequest, getUserPageCommentsRequest, getUserPageStatusRequest, getUserPageUserDataRequest, logInUserPageRequest, logoutUserPageRequest, setUpUserPageRequest, unAssignTaskFromUser, updateCustomFieldValueRequest, };
